import { RefObject } from "react";
import styled from "styled-components";
import { zIndex } from "../../styles/constants";
import { minMedium } from "../../styles/tokens";
import { ToastMessageProps } from "./toast-message/ToastMessage.Parts";

// TEXT

// STYLES
export const ToastContainer = styled.ul`
  margin: 0;
  padding: 0;
  gap: 1.5rem;
  width: 100%;
  bottom: 50%;
  display: flex;
  position: fixed;
  translate: 0 50%;
  z-index: ${zIndex.toast};
  align-items: center;
  pointer-events: none;
  flex-direction: column-reverse;

  @media ${minMedium} {
    left: 1.5rem;
    width: auto;
    translate: 0;
    align-items: flex-start;
    bottom: calc(5rem + 1.5rem);
  }
`;

// DATA

// TYPES
export type ToastContext = {
  addToast: (props: Omit<ToastMessageProps, "id" | "removeToast">) => string;
  removeToast: (id: string) => void;
  toastContainerRef: RefObject<HTMLUListElement | null>;
};

export type Props = {
  children: React.ReactNode;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
